<template>
  <div id="selfStudy_list">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="screen">
      <div class="screenBox">
        <a
          v-for="(item, index) in typeList"
          :key="item.Id"
          :class="{ side: bqflNumber == item.Id }"
          @click="bqfl(item, 'bqflNumber')"
          >{{ item.Name }}<span>套卷练习</span></a
        >
      </div>
      <div class="clearfix screen_2">
        <p class="screen_left_2">
          <strong>套题类型：</strong>
          <span>
            <a
              :class="{ side: kmNum == -2 }"
              @click="
                bqfl(
                  {
                    Id: -2,
                    Name: '不限',
                    Type: 2
                  },
                  'kmNum'
                )
              "
              >不限</a
            ></span
          >
          <span class="inline_tag">
            <a
              :class="{ side: kmNum == item.Id }"
              @click="bqfl(item, 'kmNum')"
              v-for="item in pulloverList"
              :key="item.Id"
              >{{ item.Name }}</a
            >
          </span>
        </p>
        <!-- 搜索 -->
        <div class="search">
          <input
            type="text"
            ref="ipt"
            placeholder="搜索"
            v-model="searchValue"
            @keyup.enter="searchEnter"
            @focus="searchfocus(1)"
            @blur="searchblur(2)"
          />
        </div>
      </div>
    </div>
    <div class="main_box">
      <div class="main" v-show="kcflNum == -1" v-loading="loading2">
        <a
          ref="a_jump"
          class="box-card"
          v-for="(item, index) in dataList"
          :key="item.Id"
          target="_blank"
        >
          <div class="card_item">
            <div class="main-left">{{ item.Title }}</div>
            <div class="main-right">
              <!-- <div class="people_count" v-if="bqflNumber!=3">
                <div class="gray">已答</div>
                <div>{{ item.AnswerCount }}人</div>
              </div> -->
              <div class="score">
                <div
                  v-if="item.Transcript"
                  class="score_div"
                  @click.stop="todetail(item,99)"
                >
                  <!-- <span v-if="bqflNumber != 3">得分：{{ item.Score }}</span> -->
                  <span>历史记录</span>
                </div>
              </div>
              <div v-if="isUnfinished(item)" class="df_view">
                <div
                  class="btn_status btn_status_2"
                  @click="todetail(item, 1)"
                >
                  <img
                    src="@/assets/practiceSystem/reset_answer_icon.png"
                    class="answer_icon"
                    alt=""
                  />
                  重新答题
                </div>
                <div
                  class="btn_status btn_status_1"
                  @click="todetail(item, 3)"
                >
                  <img
                    src="@/assets/practiceSystem/continue_answer_icon.png"
                    class="answer_icon"
                    alt=""
                  />
                  继续答题
                </div>
              </div>
              <div
                class="btn_status"
                v-else
                @click="todetail(item, 2)"
              >
                去答题
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
        </a>
      </div>
      <div class="pagination_footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          :total="total"
          background
          layout="total,prev, pager, next, jumper,->"
        >
        </el-pagination>
      </div>
    </div>
    <cdkey-modal ref="CDKModal">
      <template #modalMIddle>
        <div class="cdk_modal_main">
          <img
            src="@/assets/practiceSystem/modal_close.png"
            class="modal_close_icon"
            alt=""
            @click="modalClose"
          />
          <img
            src="@/assets/practiceSystem/cdk_modal_img.png"
            class="modal_img"
            alt=""
          />
          <div class="tips_modal">请联系您的留学/考培顾问，获取试卷兑换码</div>
          <div class="btn_modal" @click="modalClose">确定</div>
        </div>
      </template>
    </cdkey-modal>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
import cdkeyModal from "@/components/modal/cdkeyModal";
import banner from "../../page2/banner/banner.vue"; //头部banner图
import { getRandom } from "@/common/utils";
import { setEncryption } from "@/api/common";
export default {
  name: "practiceSystemList",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,

    banner,
    cdkeyModal
  },
  data() {
    return {
      pageTypeId: 37,
      screenup: false,
      typeList: [], //课程分类数据
      specialList: [], //专项分类数据
      pulloverList: [], //套题数据
      themeList: [], //题材数据
      difficultyList: [], //难度数据
      bqflNumber: "",
      kcflNum: "",
      kmNum: "",
      tiCai: "",
      nanDu: "",
      pxID: 1,
      total: 0,
      searchValue: "",
      tokenkey: "",
      currentPage: 1, // 当前页码
      limit: 10, //每页条数,
      dataList: [],
      greCount: 0,
      loading2: false
    };
  },
  async created() {
    let that = this;
    this.tokenkey = this.$cookies.get("token");
    this.getGREMathNumber();
    await this.getKPTestsModelType("", "", "DifficultyType", 4);
    this.getKPTestsModelType();
    if (that.$route.query.type) {
      setTimeout(() => {
        var query = that.$route.query.type;
        let typeId = that.typeList.findIndex(x => x.Name == query);
        console.log(query, typeId, "typeId");
        that.bqfl(that.typeList[typeId], "bqflNumber");
      }, 500);
    }
  },
  methods: {
    modalClose() {
      this.$refs.CDKModal.close();
    },
    iconShrink() {
      this.screenup = true;
    },
    iconOpen() {
      this.screenup = false;
    },
    getMoKaoList(url = "") {
      this.loading2 = true;
      this.dataList = [];
      let baseUrl =
        "https://schoolapi.eiceducation.com.cn/api/KPTestsTestPaper";
      let ids = "";
      // if (this.$store.state.userInfo.Type == 2) {
      //   baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsTestPaper";
      // } else if (
      //   this.$store.state.userInfo.VipList &&
      //   this.$store.state.userInfo.VipList.some(item1 => item1.VipType == 1)
      // ) {
      //   baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsTestPaper";
      //   ids = this.$store.state.userInfo.VipList.reduce(
      //     (prev, cur, index, arr) => {
      //       return prev + (cur.ContentIds ? cur.ContentIds + "," : "");
      //     },
      //     ""
      //   );
      // }
      this.$http
        .get(
          `${baseUrl}?${url}&order=${this.pxID}&page=${this.currentPage}&limit=${this.limit}`,
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: this.tokenkey
            }
          }
        )
        .then(res => {
          if (res.data.succ) {
            let { results, count } = res.data;
            this.dataList = results;
            this.dataList.forEach((item, index) => {
              item.sortIndex = index + 1;
            });
            this.total = count;
            this.loading2 = false;
          }
        });
    },
    // 其他列表
    getOtherList(url = "") {
      this.loading2 = true;
      this.dataList = [];
      console.log("this.isVip ", this.$store.state.userInfo);
      let vipTestPaperIds = "";
      let baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsSection";
      // if (this.$store.state.userInfo.Type == 2) {
      //   baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsSection";
      // } else if (
      //   this.$store.state.userInfo.VipList &&
      //   this.$store.state.userInfo.VipList.some(item1 => item1.VipType == 1)
      // ) {
      //   baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsSection";
      //   vipTestPaperIds = this.$store.state.userInfo.VipList.reduce(
      //     (prev, cur, index, arr) => {
      //       return prev + (cur.ContentIds ? cur.ContentIds + "," : "");
      //     },
      //     ""
      //   );
      // }
      this.$http
        .get(
          `${baseUrl}?${url}&order=${this.pxID}&page=${this.currentPage}&limit=${this.limit}`,
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: this.tokenkey
            }
          }
        )
        .then(res => {
          if (res.data.succ) {
            let { results, count } = res.data;
            this.dataList = results;
            this.dataList.forEach((item, index) => {
              item.sortIndex = index + 1;
            });
            this.total = count;
            this.loading2 = false;
          }
        });
    },
    //枚举类型
    async getKPTestsModelType(
      pId = "",
      type = "",
      code = "CourseType",
      all = 1
    ) {
      await this.$http
        .get(
          `https://schoolapi.eiceducation.com.cn/api/KPTestsModelType?pId=${pId}&type=${type}&code=${code}`
        )
        .then(res => {
          if (res.data.succ) {
            let { results } = res.data;
            // if(code=="CourseType"){
            //   results = results.filter(item => item.Id != 3);
            // }
            if (results.length) {
              switch (all) {
                case 1:
                  this.bqflNumber = results[0].Id;
                  this.typeList = results;
                  if (this.typeList.length) {
                    this.getKPTestsModelType(results[0].Id, "", "", 2);
                  }
                  break;
                case 2:
                  this.specialList = results.filter(item => item.Type == 1);
                  this.specialList.unshift({
                    Id: -1,
                    Name: "模考",
                    Type: 1
                  });
                  if (this.specialList.length) {
                    this.kcflNum = this.specialList[0].Id;
                  }
                  this.pulloverList = results.filter(item => item.Type == 2);
                  this.kmNum = -2;
                  if (this.typeList.length) {
                    let url = `courseType=${this.bqflNumber}`;
                    this.getMoKaoList(url);
                  }
                  break;
                case 3:
                  this.themeList = results;
                  this.tiCai = -3;
                  break;
                case 4:
                  this.difficultyList = results;
                  this.nanDu = -4;
                  break;
              }
            }
          }
        })
        .catch(function() {
          // console.log('错误');
        });
    },
    filterUrl(url) {
      let { bqflNumber, searchValue, kcflNum, kmNum, tiCai, nanDu } = this;
      if (String(bqflNumber)) {
        url += `courseType=${bqflNumber}`;
      }
      searchValue = $.trim(searchValue);
      if (searchValue) {
        url += `&keyword=${searchValue}`;
      }
      if (String(kmNum) && kmNum != -2) {
        url += `&setQuestionType=${kmNum}`;
      }
      if (kcflNum != -1 && String(kcflNum)) {
        url += `&subjectType=${kcflNum}`;
      }
      if (kcflNum != -1 && tiCai != -3 && String(tiCai)) {
        url += `&themeType=${tiCai}`;
      }
      if (kcflNum != -1 && nanDu != -4 && String(nanDu)) {
        url += `&difficultyType=${nanDu}`;
      }
      return url;
    },
    getList(isRestPage = true) {
      if (isRestPage) {
        this.currentPage = 1;
      }
      let url = "";
      url = this.filterUrl(url);
      if (this.kcflNum == -1) {
        this.getMoKaoList(url);
      } else {
        this.getOtherList(url);
      }
    },
    getGREMathNumber() {
      let baseUrl = "https://schoolapi.eiceducation.com.cn/api/GREMathNumber";
      this.$http
        .get(`${baseUrl}`, {
          headers: {
            "content-type": "application/json; charset=utf-8",
            token: this.tokenkey
          }
        })
        .then(res => {
          if (res.data.succ) {
            let { results } = res.data;
            this.greCount = results;
          }
        });
    },

    //课程
    async bqfl(itemData, type) {
      this[type] = itemData.Id;
      console.log(itemData, type, "itemData, type");
      if (type == "bqflNumber") {
        this.searchValue = "";
        this.currentPage = 1;
        this.getKPTestsModelType(itemData.Id, "", "", 2);
      } else {
        if (type == "kcflNum" && itemData.Id != -1) {
          await this.getKPTestsModelType(itemData.Id, "", "", 3);
          this.getList();
        } else {
          this.getList();
        }
      }
    },
    //排序方式
    SortMode(e) {
      this.pxID = e;
      this.getList();
    },
    searchfocus(e) {
      this.enter = e;
    },
    searchblur(e) {
      this.enter = e;
    },
    searchEnter() {
      document.onkeydown = e => {
        //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
        if (e.keyCode === 13 && this.enter == 1) {
          //回车后执行搜索方法
          this.$refs.ipt.blur();
          this.getList();
        }
      };
    },
    searchClick() {
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList(false);
    },
    judgeIsAnswer() {
      let flag = false;
      if (this.$store.state.userInfo.Type == 2) {
        flag = true;
      } else if (
        this.$store.state.userInfo.VipList &&
        this.$store.state.userInfo.VipList.some(item1 => item1.VipType == 1)
      ) {
        flag = true;
      }
      return flag;
    },
    async todetail(itemData,  restart) {
      if (this.tokenkey) {
        if (!itemData.IsPublic && !this.judgeIsAnswer()) {
          this.$refs.CDKModal.open();
          return;
        }
        this.$utils.gatAllNavUrl({
          ...itemData,
          paperId: itemData.TestPaperId,
          restart,
          isPractice:1,
          a_flag: restart == 99 ? 2 : 1,
          transcript:itemData.SetQuestionType==1662&& restart==3&&[3].indexOf(itemData.CourseType-0)>-1?itemData.UnfinishedId:itemData.Transcript,
        });
      } else {
        // 判断登录弹窗
        return (this.$refs.header.$refs.login.logintc = true);
      }
    },
    // async toResult(itemData) {
    //   if (this.tokenkey) {
    //     let { bqflNumber, kcflNum } = this;
    //     // TODO
    //     //改域名
    //     let baseUrl = this.$utils.getWindowNavUrl(1);
    //     let url = "";
    //     if (bqflNumber == 3) {
    //       if (String(kcflNum) && kcflNum == -1) {
    //         url = `${baseUrl}/toefl/results?testPaperId=${itemData.Id}&transcriptId=${itemData.Transcript}`;
    //       } else if (String(kcflNum) && kcflNum != -1) {
    //         switch (parseInt(kcflNum)) {
    //           case 28: //听力
    //             url = `${baseUrl}/toefl/listening/result?sectionId=${itemData.Id}&transcriptId=${itemData.AnswerSectionId}`;
    //             break;
    //           case 27: //阅读
    //             url = `${baseUrl}/toefl/reading/result?sectionId=${itemData.Id}&transcriptId=${itemData.AnswerSectionId}`;
    //             break;
    //           case 30: //写作
    //             url = `${baseUrl}/toefl/writing/result?sectionId=${itemData.Id}&transcriptId=${itemData.AnswerSectionId}`;
    //             break;
    //           case 29: //口语
    //             url = `${baseUrl}/toefl/speaking/result?sectionId=${itemData.Id}&transcriptId=${itemData.AnswerSectionId}`;
    //             break;
    //         }
    //       }
    //     } else if (bqflNumber == 4) {
    //       baseUrl = this.$utils.getWindowNavUrl(3);
    //       if (String(kcflNum) && kcflNum == -1) {
    //         url = `${baseUrl}/testResult?id=${itemData.Id}&type=test`;
    //       } else if (String(kcflNum) && kcflNum != -1) {
    //         url = `${baseUrl}/sectionResult?id=${itemData.Id}&type=section`;
    //       }
    //     } else if (bqflNumber == 2) {
    //       baseUrl = this.$utils.getWindowNavUrl(2);
    //       if (String(kcflNum) && kcflNum == -1) {
    //         url = `${baseUrl}/comprehensive-result?sectionId=${itemData.Id}&pageMeta=1`;
    //       } else if (String(kcflNum) && kcflNum != -1) {
    //         url = `${baseUrl}/result?sectionId=${itemData.Id}&pageMeta=${itemData.SubjectType}`;
    //       }
    //     } else if (bqflNumber == 607) {
    //       baseUrl = this.$utils.getWindowNavUrl(4);
    //       if (String(kcflNum) && kcflNum == -1) {
    //         url = `${baseUrl}/comprehensive-result?sectionId=${itemData.Id}&pageMeta=1&transcriptId=${itemData.Transcript}`;
    //       } else if (String(kcflNum) && kcflNum != -1) {
    //         url = `${baseUrl}/section-result?sectionId=${itemData.Id}&pageMeta=${itemData.SubjectType}&transcriptId=${itemData.AnswerSectionId}`;
    //       }
    //     }
    //     let tempWindow = window.open("/loading", getRandom(999, 100));
    //     let res = await setEncryption({
    //       token: this.$cookies.get("token")
    //     });
    //     if (res.data.code == 200) {
    //       tempWindow.location.href = `${url}&ep=${
    //         res.data.results
    //       }&timestamp=${getRandom(999, 100)}`;
    //     } else {
    //       tempWindow.close();
    //     }
    //   } else {
    //     // 判断登录弹窗
    //     return (this.$refs.header.$refs.login.logintc = true);
    //   }
    // },
    toNavRandom() {
      let tempWindow = window.open("/loading", getRandom(999, 100));
      let baseUrl =
        "https://schoolapi.eiceducation.com.cn/api/KpTestsRandomSection";
      this.$http
        .get(`${baseUrl}`, {
          headers: {
            "content-type": "application/json; charset=utf-8",
            token: this.tokenkey
          }
        })
        .then(async res => {
          if (res.data.succ) {
            let { results } = res.data;
            let baseUrl = this.$utils.getWindowNavUrl(3);
            let url = `${baseUrl}/progress?id=${results}&type=${"section"}`;
            let res1 = await setEncryption({
              token: this.$cookies.get("token")
            });
            if (res1.data.code == 200) {
              tempWindow.location.href = `${url}&ep=${
                res1.data.results
              }&timestamp=${getRandom(999, 100)}`;
            } else {
              tempWindow.close();
            }
          }
        });
    },
        // 判断是否显示未完成状态
        isUnfinished(item) {
      // 如果 CourseType 是 2 或 3，检查 UnfinishedId 是否存在
      if ([3].indexOf(item.CourseType-0)>-1&&item.SetQuestionType==1662) {
        return item.UnfinishedId;
      }
      // 否则检查 Unfinished 是否存在
      return item.Unfinished;
    }
  }
};
</script>
<style scoped lang="less">
.text__overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.tab_boxs {
  overflow: hidden;
  transition: 0.2s;
  height: 51px;
}

.df_view {
  display: flex;
  gap: 20px;
  .btn_status {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    &.btn_status_1 {
      color: #337cff;
    }
    &.btn_status_2 {
      color: #15ceb2;
    }
    .answer_icon {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
  }
}

.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.header_left {
  background: #f00;
}

.banner {
  width: 100%;
  height: 452px;
  position: relative;
  overflow: hidden;
}

.banner img {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -960px;
}

.screen {
  background: #fff;
  padding-top: 30px;
}

.screenBox {
  width: 862px;
  height: 126px;
  margin: 0 auto;
  background: url(../../assets/courselist/searchBj1.png) no-repeat;
  background-size: 1200px 160px;
  margin-bottom: 50px;
  padding-left: 338px;
  padding-top: 34px;
}

.screenBox a {
  display: block;
  width: 141px;
  height: 73px;
  margin-right: 30px;
  background: url(../../assets/courselist/search5.png) left no-repeat;
  background-size: 140px 75px;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 20px;
  padding-top: 27px;
  padding-left: 19px;
  cursor: pointer;
  float: left;
}

.screenBox a span {
  display: block;
  padding-top: 9px;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 12px;
}

.screenBox a:nth-child(1).side {
  background: url(../../assets/courselist/search1.png) no-repeat;
  background-size: 150px 100px;
  color: rgba(51, 124, 255, 1);
}

.screenBox a:nth-child(2).side {
  background: url(../../assets/courselist/search2.png) no-repeat;
  background-size: 150px 100px;
  color: rgba(51, 124, 255, 1);
}

.screenBox a:nth-child(3).side {
  background: url(../../assets/courselist/search3.png) no-repeat;
  background-size: 150px 100px;
  color: rgba(51, 124, 255, 1);
}

.screenBox a:nth-child(4).side {
  background: url(../../assets/courselist/search4.png) no-repeat;
  background-size: 150px 100px;
  color: rgba(51, 124, 255, 1);
}

.screenBox a:nth-child(1).side span {
  color: rgba(51, 124, 255, 1);
}

.screenBox a:nth-child(2).side span {
  color: rgba(51, 124, 255, 1);
}

.screenBox a:nth-child(3).side span {
  color: rgba(51, 124, 255, 1);
}

.screenBox a:nth-child(4).side span {
  color: rgba(51, 124, 255, 1);
}

.screen_2 {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  .screen_left_2 {
    width: calc(100% - 250px);
  }
}

.screen_2 p {
  text-align: left;
  display: table;
  height: 28px;
}

.screen_2 p strong {
  display: inline-block;
  width: 100px;
  font-weight: 400;
  font-size: 20px;
  color: #666666;
  line-height: 28px;
  float: left;
}

.screen_2 p span {
  display: inline-block;
  /* width: 1080px; */
  float: left;
  cursor: pointer;
}

.screen_2 p a {
  display: inline-block;
  min-width: 75px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 28px;
  border-radius: 14px;
  text-align: left;
  cursor: pointer;
  padding: 0 20px;
  box-sizing: border-box;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.screen_2 p a:hover {
  color: rgba(51, 124, 255, 1);
  cursor: pointer;
}

.screen_2 p a.side {
  background: rgba(51, 124, 255, 0.05);
  color: rgba(51, 124, 255, 1);
  cursor: pointer;
}

.main_box {
  background-color: #ffffff;
}

.main,
.other_main {
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  min-height: 300px;
}

.main .box-card {
  display: block;
  width: 1200px;
  height: 76px;
  background: #ffffff;
  padding: 0 30px;
  box-sizing: border-box;
  cursor: pointer;
  border-bottom: 1px rgba(216, 216, 216, 1) solid;
}

.card_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.card_item .main-left {
  flex: 1;
  min-width: 0;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 76px;
  text-align: left;
}

.card_item .main-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 76px;
}

.people_count,
.score {
  display: inline-block;
  text-align: center;
  margin-right: 30px;
}

.people_count {
  margin-right: 12px;
}

.gray {
  color: #999999;
}

.other_item {
  display: block;
  margin-bottom: 12px;
  background-color: #fff;
  width: 1180px;
  height: 86px;
  background: #ffffff;
  border-radius: 12px;
  padding: 0 28px;
  box-sizing: border-box;
  cursor: pointer;
}

.other_item .left {
  float: left;
  display: flex;
  align-items: center;
  height: 100%;
}

.affiliated {
  width: 120px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  text-align: center;
}

.difficulty {
  padding: 0 24px 0 20px;
}

.difficulty .num {
  font-size: 20px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  padding-bottom: 14px;
}

.difficulty .num_tip {
  border-radius: 1px;
  font-size: 20px;
  font-family: SourceHanSansCN-Light, SourceHanSansCN;
  font-weight: 300;
  color: #ff3350;
  line-height: 20px;
  text-align: center;
  padding: 2px;
}

.name_box {
  width: 420px;
}

.name_box .name {
  font-size: 20px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  padding-bottom: 16px;
}

.name_box .desc {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}

.other_item .right {
  float: right;
  display: flex;
  align-items: center;
  height: 100%;
}

.people_box,
.questions_count,
.answer_box {
  width: 120px;
  background: #f8f8f8;
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  padding: 10px 0 8px 0;
  box-sizing: border-box;
  margin-right: 12px;
}

.answer_box {
  margin-right: 22px;
}

.pagination_footer {
  padding: 31px 0 52px 0;
  width: 1180px;
  text-align: right;
  margin: 0 auto;
}

.screen_S {
  width: 1180px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 40px;
}

.screen_S input {
  width: 250px;
  height: 36px;
  background: #ffffff;
  border-radius: 21px;
  border: 1px solid #dddddd;
  padding: 0 15px;
}

.screen_S .search_btn {
  position: absolute;
  top: 1px;
  left: 245px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border: none;
  background: url(../../assets/personal/icon_search_Default.png) no-repeat;
  overflow: hidden;
  text-indent: -999px;
}

.inline_tag {
  // width: 995px !important;
}

.score_div {
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  color: #337cff;
  text-decoration-line: underline;
}

.progress_cirle {
  width: 52px;
  height: 55px;
}
.search {
  width: 200px;
  height: 42px;
  background: #ffffff;
}

.search input {
  box-sizing: border-box;
  width: 100%;
  height: 42px;
  background: #ffffff;
  border-radius: 21px;
  border: 1px solid #dddddd;
  padding-left: 20px;
  background: url(../../assets/index/search.png) 16px no-repeat;
  background-size: 24px 24px;
  padding-left: 48px;
  font-size: 16px;
}
.cdk_modal_main {
  width: 800px;
  position: relative;
  text-align: center;
  .modal_close_icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 37px;
    height: 37px;
    cursor: pointer;
  }
  .modal_img {
    width: 375px;
    height: 330px;
  }
  .tips_modal {
    font-size: 24px;
    color: #333333;
    margin: 20px 0 40px;
  }
  .btn_modal {
    cursor: pointer;
    width: 160px;
    height: 42px;
    line-height: 42px;
    background: #ff0659;
    border-radius: 21px 21px 21px 21px;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/page2/practiceSystem/list.vue